var Iframe_default = {
  "iframe": "nPAoF"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
